/* This file is autogenerated, see readme.md for instructions */
import ArrowExpandSvgIcon from '@bloomreach/banana-theme/icons/arrow-expand.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowExpandIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowExpandSvgIcon />
    </Icon>
  );
});

ArrowExpandIcon.displayName = 'ArrowExpandIcon';

export default ArrowExpandIcon;
